document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.about-accordion').forEach(function (root) {
    function togglePanel(button, panel) {
      var isOpen = button.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        // Collapse
        panel.style.height = panel.scrollHeight + 'px';
        requestAnimationFrame(function () {
          panel.style.height = '0px';
        });
        button.setAttribute('aria-expanded', 'false');
        panel.addEventListener('transitionend', function onEnd() {
          panel.hidden = true;
          panel.style.removeProperty('height');
          panel.removeEventListener('transitionend', onEnd);
        });
      } else {
        // Expand
        panel.hidden = false;
        panel.style.height = '0px';
        var target = panel.scrollHeight;
        requestAnimationFrame(function () {
          panel.style.height = target + 'px';
        });
        button.setAttribute('aria-expanded', 'true');
        panel.addEventListener('transitionend', function onEnd() {
          panel.style.removeProperty('height');
          panel.removeEventListener('transitionend', onEnd);
        });
      }
    }

    // Item accordions
    root.querySelectorAll('.about-accordion__item').forEach(function (item) {
      var button = item.querySelector('.about-accordion__item-title');
      var panel = item.querySelector('.about-accordion__item-panel');
      if (!button || !panel) return;

      panel.style.transition = 'height 0.3s ease';
      panel.style.overflow = 'hidden';

      button.addEventListener('click', function () {
        togglePanel(button, panel);
      });
    });

    // Optional top-heading toggle
    var mainButton = root.querySelector('.about-accordion__title.is-toggle');
    if (mainButton) {
      var mainPanel = document.getElementById(mainButton.getAttribute('aria-controls'));
      if (mainPanel) {
        mainPanel.style.transition = 'height 0.3s ease';
        mainPanel.style.overflow = 'hidden';
        mainButton.addEventListener('click', function () {
          togglePanel(mainButton, mainPanel);
        });
      }
    }
  });
});